<template>
  <div class="container my-5 text-center">
    <div class="row justify-content-center">
      <div class="col-12">
        <!-- <h1 class="main-title mb-3">{{ $t('food_machine.title') }}</h1>
        <p class="sub-title mb-5">{{ $t('food_machine.subtitle') }}</p> -->
        <div class="image-container">
          <img src="/inritek-web/images/food_machine_process.jpg" alt="Food Machine Process" class="img-fluid process-image">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Logic can be added here if needed
</script>

<style scoped>
.main-title {
  color: #003366; /* Dark Blue */
  font-weight: bold;
  font-size: 2.5rem;
}

.sub-title {
  color: #808080; /* Gray */
  font-size: 1.25rem;
}

.process-image {
  max-width: 100%;
  height: auto;
  border-radius: 8px; /* Optional: adds a bit of polish */
  box-shadow: 0 4px 6px rgba(0,0,0,0.1); /* Optional: adds depth */
}
</style>
